export default __webpack_public_path__ + "static/media/icon-hazard-fill.fbd91d16.svg";